var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 row d-flex justify-content-between"},[_c('div',{staticClass:"col col-12 col-md-9 display-4"},[_vm._t("default")],2),_c('div',{staticClass:"col col-12 col-md-3 text-right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }